import React, { useState } from 'react';
import { Label, Input, FormFeedback } from 'reactstrap';
import { OnChangeCallback } from '../../util/UtilityTypes'

interface NullableInputProps {
    title?: string
    name: string
    value?: string | null
    checkboxTitle?: string
    titleSmall?: boolean
    disabled?: boolean
    invalid?: boolean
    invalidFeedback?: string
    maxLength?: number
    placeholder?: string
    className?: string
    inputClassName?: string
    onChange: OnChangeCallback<string | null>
}

const NullableInput: React.FC<NullableInputProps> = (props) => {
    const [checked, setChecked] = useState(props.value !== null && props.value !== undefined)
    const [previous, setPrevious] = useState(props.value ?? '')

    const toggle = (shouldBeChecked: boolean) => {
        setChecked(shouldBeChecked);
        const value = shouldBeChecked ? previous : null;
        
        props.onChange(props.name, value)
    }

    const onChange = (value: string) => {
        setPrevious(value);
        props.onChange(props.name, value);
    }

    const onClickDisabled = () => {
        if (!props.disabled && !checked) {
            toggle(true)
        }
    }

    const containerClassName = props.className ?? 'mb-3';
    const inputClassName = props.inputClassName ?? "md-w-50 lg-w-25";

    return (
        <div className={containerClassName}>
            {props.title && (props.titleSmall ? <Label style={{ display: 'block' }}>{props.title}</Label> : <h5>{props.title}</h5>)}
            <div className="form-check">
                <Input type="checkbox" style={{ marginTop: '10px' }} title={props.checkboxTitle}
                    disabled={props.disabled}
                    checked={checked}
                    onChange={(e) => toggle(e.target.checked)}
                />
                <div onClick={onClickDisabled} style={{ marginLeft: '10px' }}>
                    <Input className={inputClassName} type="text" name={props.name} id={props.name}
                        value={props.value ?? ''}
                        disabled={props.disabled || !checked}
                        onChange={(e) => onChange(e.target.value)}
                        invalid={props.invalid}
                        maxLength={props.maxLength}
                        placeholder={props.placeholder}
                    />
                    <FormFeedback>{props.invalidFeedback}</FormFeedback>
                </div>
            </div>
        </div>
    );
}

export default NullableInput;
